import { Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import "./index.css";
import "./App.css";
import Home from "./Screens/Home/Home";
import PropertiesDetails from "./Screens/Properties/PropertiesDetails";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Loader from "./Components/Loader/Loader";
import ScrollToTop from "./ScrollToTop";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import ApplicationToLease from "./Screens/Properties/ApplicationToLease";

function App() {
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = searchParams.get("lang");
    if (lang) i18n.changeLanguage(lang);
  }, [searchParams, i18n]);
  return (
    <div>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/properties" element={<Home />} />
        <Route path="/properties/properties-details/:id" element={<PropertiesDetails />} />
        <Route path="*" element={<Navigate to="/properties" replace />} />
        <Route path="/properties/applicationToLease" element={<ApplicationToLease />} />
      </Routes>
      <Footer />
      <Loader />
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
    </div>
  );
}

export default App;
